import { defineType } from 'sanity';

export default defineType({
	name:   'contactUsPage',
	title:  'Contact Us Page',
	type:   'document',
	fields: [
		{
			name:    'image',
			title:   'Image',
			type:    'image',
			options: { hotspot: true },
		},
		{
			name:  'title',
			title: 'Title',
			type:  'localizedText',
		},
		{
			name:  'description',
			title: 'Description',
			type:  'localizedText',
		},
		{
			name:   'address',
			title:  'Address',
			type:   'object',
			fields: [
				{
					name:       'title',
					title:      'Title',
					type:       'localizedText',
					validation: Rule => Rule.required(),
				},
				{
					name:       'address',
					title:      'Address',
					type:       'localizedText',
					validation: Rule => Rule.required(),
				},
			],
		},
		{
			name:   'contact',
			title:  'Contact',
			type:   'object',
			fields: [
				{
					name:       'title',
					title:      'Title',
					type:       'localizedText',
					validation: Rule => Rule.required(),
				},
				{
					name:       'email',
					title:      'Email',
					type:       'string',
					validation: Rule => Rule.required(),
				},
			],
		},
		{
			name:   'followUs',
			title:  'Follow Us',
			type:   'object',
			fields: [
				{
					name:       'title',
					title:      'Title',
					type:       'localizedText',
					validation: Rule => Rule.required(),
				},
				{
					name:       'line',
					title:      'Line',
					type:       'string',
					validation: Rule => Rule.required(),
				},
				{
					name:       'facebook',
					title:      'Facebook',
					type:       'string',
					validation: Rule => Rule.required(),
				},
				{
					name:       'instagram',
					title:      'Instagram',
					type:       'string',
					validation: Rule => Rule.required(),
				},
				{
					name:       'tiktok',
					title:      'Tiktok',
					type:       'string',
					validation: Rule => Rule.required(),
				},
			],
		},
	],
	preview: { prepare: () => ({ title: 'Contact Us Page' }) },
});
